<template>
  Overview
</template>

<script>
import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';

export default {
  name: 'OverviewView',
  computed: {
    ...mapState(useSurveyStore, ['surveyIdentifier']),
  },
  mounted() {
    if (this.surveyIdentifier) {
      this.$router.push(`/survey/${this.surveyIdentifier}`);
    } else {
      this.$router.push('/survey/main');
    }
  },
};
</script>
